import React, { FC } from "react";
import "./styles.scss";
import { ClosedChatMessageSectionProps } from "./props";

export const ClosedChatMessageSection: FC<ClosedChatMessageSectionProps> = ({
  userName,
  phone,
  email,
}) => {
  return (
    <div className="closed-chat-message-section">
      <div className="closed-chat-message-section__text">
        <strong>{userName}</strong>&nbsp;
        applied through the public page without having an account and cannot be messaged through this chat. 
        You can contact&nbsp;{userName}&nbsp;directly via
      </div>

      <div className="closed-chat-message-section__text">
        <a 
          className="closed-chat-message-section__link"
          href={`mailto:${email}`}
        >
          {email}
        </a>&nbsp;
        {!!phone?.length && (
          <>
            or&nbsp;
            <span className="closed-chat-message-section__link">
              {phone}
            </span>
          </>
        )}
      </div>
    </div>
  );
}
